<template>
  <div>
    <v-menu
      v-model="menuValue"
      transition="slide-y-transition"
      bottom
      left
      max-width="auto"
    >
      <template v-slot:activator="{ on }">
        <div :class="$vuetify.breakpoint.mobile ? 'px-2' : 'mr-1'">
          <v-btn
            v-on="on"
            text
            block
            class="px-2"
            :class="{ active: menuValue }"
          >
            <div v-if="lang == 'pt'" class="d-flex align-center">
              <img
                :src="$languageFlagUrl('br')"
                alt="flag"
                width="24px"
              />
              <span v-if="$vuetify.breakpoint.xsOnly" class="overline ml-4">{{
                $t("portuguese")
              }}</span>
            </div>
            <span v-if="lang == 'es'">
              <img
                :src="$languageFlagUrl('es')"
                alt="flag"
                width="24px"
              />
              <span v-if="$vuetify.breakpoint.xsOnly" class="overline ml-4">{{
                $t("spanish")
              }}</span>
            </span>
            <span v-if="lang == 'en'">
              <img
                :src="$languageFlagUrl('uk')"
                alt="flag"
                width="24px"
              />
              <span v-if="$vuetify.breakpoint.xsOnly" class="overline ml-4">{{
                $t("english")
              }}</span>
            </span>
            <v-icon right color="grey lighten-2">mdi-menu-down</v-icon>
          </v-btn>
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            top
            absolute
          ></v-progress-linear>
        </div>
      </template>
      <v-card>
        <v-list>
          <v-list-item
            @click="changeFlag('pt')"
            :disabled="$i18n.locale === 'pt'"
          >
            <v-list-item-action>
              <img
                class="mr-2"
                width="24"
                :src="$languageFlagUrl('br')"
              />
            </v-list-item-action>

            <v-list-item-title class="overline"
              >{{ $t("portuguese") }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="changeFlag('es')"
            :disabled="$i18n.locale === 'es'"
          >
            <v-list-item-action>
              <img
                class="mr-2"
                width="24"
                :src="$languageFlagUrl('es')"
              />
            </v-list-item-action>

            <v-list-item-title class="overline">
              {{ $t("spanish") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="changeFlag('en')"
            :disabled="$i18n.locale === 'en'"
          >
            <v-list-item-action>
              <img
                class="mr-2"
                width="24"
                :src="$languageFlagUrl('uk')"
              />
            </v-list-item-action>

            <v-list-item-title class="overline"
              >{{ $t("english") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <!-- <h1>{{ $t("welcomeMsg") }}</h1> -->
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import getInfoTable from "@/util/infoTable";
export default {
  data: () => ({
    lang: "",
    menuValue: null,
    loading: false,
  }),
  mounted() {
    this.checklanguage();
  },
  methods: {
    // Return firstName and Iniciais do Nome
    setLocale(locale) {
      return new Promise((resolve) => {
        this.$store.commit("setLanguage", locale);
        localStorage.setItem("language", locale);
        if (locale == "pt") {
          this.$store.commit(
            "setFlagLanguage",
            "https://cdn.vuetifyjs.com/images/flags/br.png"
          );
        }
        if (locale == "es") {
          this.$store.commit(
            "setFlagLanguage",
            this.$languageFlagUrl("es")
          );
        }
        if (locale == "en") {
          this.$store.commit(
            "setFlagLanguage",
            this.$languageFlagUrl("uk")
          );
        }
        resolve(200);
      });
    },
    changeFlag(locale) {
      this.loading = true;

      this.$i18n.locale = locale;

      this.lang = locale;

      this.setLocale(locale).then((result) => {
        if (result == 200) {
          this.$axios.defaults.headers.language = locale;
          getInfoTable(true, locale)
            .then(() => {
              const soccerName = this.$store.getters.getNameSportById("6046");

              this.$router.push({
                name: this.$permissions().bigTable ? "bigTable" : "Sports",
                query: {
                  sport: soccerName,
                  live: soccerName,
                },
              });

              // this.$router.go();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    checklanguage() {
      this.lang = localStorage.getItem("language");
      // Refresh na página caso não tenha lingua
      if (this.lang == undefined) {
        this.setLocale("pt");
        this.lang = "pt";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn.active .v-icon {
  transform: rotate(180deg);
}
</style>
